import { WebPlatformApiService } from './../../../../services/WebPlatformApiService';
import { AppStateService } from './../../../../services/AppStateService';
import { DisplayStateService } from './../../../../services/DisplayStateService';
import { ClientSettingsService } from './../../../../services/ClientSettingsService';
import { timeout } from 'rxjs/operator/timeout';
import { Params } from '@angular/router';
import { Component, ViewChild, ElementRef } from '@angular/core';

import { NameValue } from '../../../../interfaces/WidgetInterfaces';
import { GenericBaseComponent } from '../generic-base/generic-base.component';
import { PlatformTableComponent } from '../../../platform-table/platform-table.component';
import { DataRequestError } from '../../../../interfaces/DisplayInterfaces';

@Component({
  selector: 'app-generic-table',
  template: `<div *ngIf="dataRequestError; else noError">
   <app-data-error-display [dataRequestError] = "dataRequestError" [parentConfig]="Config" ></app-data-error-display>
</div>

<ng-template #noError>

  <div *ngIf="displayDataSet;  else loading" class="table">

    <app-platform-table [Dataset]="displayDataSet" [Config]="Config.config" [SortAndfilterLocally]="false"
      (AddFilter)="AddFilter($event)" (RemoveFilter)="RemoveFilter($event)" (NewSort)="NewSort($event)"></app-platform-table>

  </div>
</ng-template>

<ng-template #loading>
  <i class="fa fa-spinner fa-spin"></i>
  Loading data...
</ng-template>

<ol *ngIf="displayDataSet" class="breadcrumb">
  <li class="breadcrumb-item active"><strong>Retrieved: </strong>{{cacheDataInfo.CacheDate}}</li>
  <li class="breadcrumb-item active"><strong>Cache? </strong>{{cacheDataInfo.RetrievedFromCache}}</li>
  <li class="breadcrumb-item active"><strong>Visible: </strong>{{displayDataSet.data.length}} of {{originalDataSet.data.length}}</li>

</ol>`,
  styles: [`.table-condensed>tbody>tr>td,
.table-condensed>tbody>tr>th,
.table-condensed>tfoot>tr>td,
.table-condensed>tfoot>tr>th,
.table-condensed>thead>tr>td,
.table-condensed>thead>tr>th{
    padding:2px;
    font-size:12px
}

.table-responsive{
    width:auto;
}`]
})
export class GenericTableComponent extends GenericBaseComponent {

  @ViewChild(PlatformTableComponent)
  private platformTableComponent: PlatformTableComponent;

  dataSetColors: string[][] = [];
  filteredIndexes: number[];

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
    
  NewSort(nv: NameValue) {
    this.SetSort(nv.name, nv.value);
  }

  AddFilter(nv: NameValue) {
    this.displayStateService.AddFilter(nv.name, nv.value);
  }
  RemoveFilter(filterName: string) {
    this.displayStateService.RemoveFilter(filterName);
  }

  PostProcessing() {
    // console.log('GenericTableComponent.PostProcessing');
    this.dataRequestError = undefined;
    if (this.platformTableComponent) {
      this.platformTableComponent.RefreshFromDataSet();
    }
}

GetColorStyle(row: number, col: number): string {
  // console.log(`row: ${row}, col: ${col} this.dataSetColors[row] = ${this.dataSetColors[row]}`);
  if (this.dataSetColors.length !== 0 && this.dataSetColors[row][col] !== '') {
    // console.log('.');
    return this.dataSetColors[row][col];
  } else {
    // console.log('!');
    return '';
  }
}

SetSort(colName: string, sortExpression: string) {
  const p: Params[] = [];
  p[colName] = sortExpression;
  this.displayStateService.SetSorts(p);
}

filtered(idx: number): boolean {
  return false;
  // return this.filteredIndexes.indexOf(idx) > -1;
}
}
